module.exports = __webpack_public_path__ + "static/img/platform-bg-1.30182b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/platform-bg-1.png
// module id = BenV
// module chunks = 1